import { DEFAULT_NUMBER_OF_NIGHTS } from '@constants'
import { generateIncludedDays } from '@utils/generateIncludedDays'
import { AvailabilityState, UnitType } from './types'

export const initializeAvailabilityState = (): AvailabilityState => {
  const today = new Date()
  const thirtyDaysLater = new Date()
  thirtyDaysLater.setDate(today.getDate() + 30)

  return {
    activeUnitName: UnitType.AllSuites,
    suites: [],
    selectedSuite: null,
    selectedResort: null,
    continuousDays: 0,
    minimumNights: 2,
    openToDate: undefined,
    purchaseType: 'Developer',
    isRatePlanLoaded: false,
    fetchingDates: false,
    isBonusTimeApplicableForResort: false,
    isBonusTimeEnabled: false,
    isExoticBonusTimeApplicableForResort: false,
    isExoticBonusTimeEnabled: false,
    isLoading: false,
    preLoadAvailabiliySearch: false,
    currentMonth: new Date(),
    startDate: null,
    checkInDate: null,
    endDate: null,
    checkOutDate: null,
    includedDays: generateIncludedDays([today, thirtyDaysLater], []),
    availabilityError: undefined,
    location: undefined,
    isFlexibleDates: false,
    isBonusTimeDates: false,
    isDatesBufferEnabled: false,
    selectedFlexibleDateMonths: [],
    numberOfNights: DEFAULT_NUMBER_OF_NIGHTS,
    monthYears: '',
    flexiDatesString: '',
    bonusTimeDatesString: '',
    searchConstraints: null,
    savedSearch: undefined,
    savedSearches: [],
    savedSearchesError: undefined,
    saveSearchSuccess: false,
    saveSearchError: undefined,
    deleteSearchSuccess: false,
    deleteSearchError: undefined,
    filters: undefined,
    unfilteredSearchResults: undefined,
    searchAlertMessage: '',
    searchBusinessSystemCode: '',
  }
}
